export default __webpack_public_path__ + "static/media/marketing-flow-w.c0f3e882.svg";